import { MewaCircleType, ServiceSegmentType } from './types';

/**
 * Translates service segments to mewa circle variants
 */
export const mewaCircleVariantsMap: Record<ServiceSegmentType, MewaCircleType> =
  {
    [ServiceSegmentType.businessClothing]: 'MBK',
    [ServiceSegmentType.workwear]: 'MBS',
    [ServiceSegmentType.protectiveClothing]: 'MBS',
    [ServiceSegmentType.hygieneClothing]: 'MBS',
    [ServiceSegmentType.healthClothing]: 'MBS',
    [ServiceSegmentType.serviceClothing]: 'MBS',
    [ServiceSegmentType.cleaningCloths]: 'MTS',
    [ServiceSegmentType.washroomHygiene]: 'MWS',
    [ServiceSegmentType.carCovers]: 'Toptex',
    [ServiceSegmentType.oilCollectionMats]: 'Multitex',
    [ServiceSegmentType.partsCleaner]: 'MTR',
    [ServiceSegmentType.dirtTrappingMats]: 'MFS',
    [ServiceSegmentType.wipingMops]: 'Wipingmops',
    [ServiceSegmentType.cleanRoom]: 'CleanRoom',
  };
